import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import ButtonComponent from "../elements/ButtonComponent";
import { axiosPrivate } from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { AxiosRequestConfig } from "axios";
import { useStoreContext } from "../../context/StoreContext";
import {
  LOGIN_URL,
  OTP_URL,
  FORGET_PASSWORD_VERIFY_OTP,
  USER_HOME_CONTEXT,
} from "../../api/apiClient";
import CustomTimer from "../otp-timer/CountdownTimer";
import OTPInput from "../OTP";
import { toast } from "react-toastify";

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  globalErrorHandler?: boolean;
}

const EnterOtp = ({
  isForgetPassword,
  onOtpSubmit,
  handleSubmit,
  control,
  otpClose,
  getValues,
  setValue,
  goToLogin,
  onOpemRules,
  otp_ticket,
  navigateHere,
  loginAvailable = true,
  OtpLength = 6,
  setOtp_ticket,
  setEnteredUser,
  watch,
}: any) => {
  const [styleOtpInput, setStyleOtpInput] = useState(
    "focus:border-primary-800 border-gray-300"
  );

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const { storeData } = useStoreContext();
  const [inputKey, setInputKey] = useState(0);

  const navigate = useNavigate();
  const phone_number = getValues(
    isForgetPassword ? "forget_phone_number" : "phone_number"
  );

  const otpConfirm = async () => {
    try {
      setIsButtonDisabled(true);
      setStyleOtpInput("focus:border-primary-800 border-gray-300");
      const otpCodeNumber = getValues(
        isForgetPassword ? "forget_otpCodeNumber" : "otpCodeNumber"
      );

      if (onOtpSubmit) {
        onOtpSubmit(phone_number, otpCodeNumber);
      }

      if (!otpCodeNumber) {
        setStyleOtpInput("border border-red-500 focus:border-red-500");
        return;
      }
      if (otpCodeNumber.length < OtpLength) {
        setStyleOtpInput("border border-red-500 focus:border-red-500");
        return;
      }

      const response = await axiosPrivate.post(
        isForgetPassword ? FORGET_PASSWORD_VERIFY_OTP : OTP_URL,
        {
          otp_ticket: otp_ticket,
          otp_code: otpCodeNumber,
        },
        {}
      );

      if (response.status >= 200 && response.status < 300) {
        !isForgetPassword &&
          localStorage.setItem("user_state", response?.data?.data?.user_state);
        !isForgetPassword &&
          setEnteredUser(
            response?.data?.data?.user_state === "REGISTERED" ||
              response?.data?.data?.user_state === "VERIFIED"
              ? true
              : false
          );
        if (isForgetPassword) {
          setOtp_ticket(response?.data?.data?.otp_ticket);
          onOpemRules();
        } else {
          localStorage.setItem(
            "access_token",
            String(response?.data?.data?.access_token)
          );

          const access_token = localStorage.getItem("access_token");
          localStorage.setItem("refresh", response?.data?.data?.refresh_token);
          localStorage.setItem(
            "user_state",
            String(response?.data?.data?.user_state)
          );

          if (response?.data?.data?.user_state === "NOT_REGISTERED") {
            onOpemRules();
          } else {
            if (navigateHere) {
              if (response?.status >= 200 && response.status < 300) {
                const response = await axiosPrivate.get(USER_HOME_CONTEXT, {
                  headers: {
                    // prettier-ignore
                    "Authorization": `Bearer ${access_token}`,
                    // prettier-ignore
                    "accept": "application/json",
                  },
                });
              }
              localStorage.setItem(
                "user_state",
                response?.data?.data?.user_state
              );
              setEnteredUser(
                response?.data?.data?.user_state === "REGISTERED" ||
                  localStorage.getItem("user_state") === "VERIFIED"
                  ? true
                  : false
              );

              navigate(navigateHere);
            } else {
              if (response?.status >= 200 && response.status < 300) {
                const response = await axiosPrivate.get(USER_HOME_CONTEXT, {
                  headers: {
                    // prettier-ignore
                    "Authorization": `Bearer ${access_token}`,
                    // prettier-ignore
                    "accept": "application/json",
                  },
                });
                if (response?.status >= 200 && response.status < 300) {
                  localStorage.setItem(
                    "user_state",
                    response?.data?.data?.user_state
                  );
                  setEnteredUser(
                    response?.data?.data?.user_state === "REGISTERED" ||
                      localStorage.getItem("user_state") === "VERIFIED"
                      ? true
                      : false
                  );
                }
              }
              var store_state = storeData?.store_state;

              if (store_state === "NOT_VERIFIED") {
                const body = document.querySelector("body");
                if (body) {
                  body.classList.remove("overflow-hidden");
                }

                navigate("/fa/seller-auth");
              } else if (store_state === "ACTIVE") {
                const body = document.querySelector("body");
                if (body) {
                  body.classList.remove("overflow-hidden");
                }

                navigate("/fa/dashboard");
              } else if (
                store_state === "PEND_FOR_VERIFY" ||
                store_state === "REJECTED" ||
                store_state === "ACTIVE"
              ) {
                localStorage.setItem("seller_state 2", store_state);
                const body = document.querySelector("body");
                if (body) {
                  body.classList.remove("overflow-hidden");
                }

                navigate("/fa/seller-auth");
              } else {
                navigate("/");

                const body = document.querySelector("body");
                if (body) {
                  body.classList.remove("overflow-hidden");
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setStyleOtpInput("border border-red-500 focus:border-red-500");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const handleResend = async () => {
    const access_token = localStorage.getItem("access_token");
    try {
      const response = await axiosPrivate.post(
        LOGIN_URL,
        JSON.stringify({ phone_number }),
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${access_token}`,
          },
          withCredentials: true,
        }
      );

      if (response?.status >= 200 && response?.status < 300) {
        setOtp_ticket(response?.data?.data?.otp_ticket);
        setValue("otpCodeNumber", "");
        toast.success(`کد تایید به شماره ${phone_number} ارسال شد`);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("خطا در ارسال کد تایید");
    }
  };

  useEffect(() => {
    watch &&
      ((watch && watch("forget_otpCodeNumber")?.length === OtpLength) ||
        (watch && watch("otpCodeNumber")?.length === OtpLength)) &&
      otpConfirm();
  }, [watch("forget_otpCodeNumber"), watch("otpCodeNumber")]);

  return (
    <>
      <div className=" flex items-end justify-start rounded-t pt-2">
        <button
          type="button"
          onClick={() => {
            otpClose();
          }}
          className="text-gray-400 bg-transparent rounded-lg w-8 h-8 inline-flex justify-end items-center  "
        >
          <img src="/icons/arrow-right-outline.svg" alt="back icon" />
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <div className="mx-8">
        <form onSubmit={handleSubmit(otpConfirm)}>
          <div className="flex flex-col gap-4 text-center max-h-[356px]">
            <div className="flex flex-col items-center justify-center gap-8">
              <img
                src="/icons/LogoNamePlusFinger.svg"
                className="w-[113px] h-[36px]"
                alt="logo vam30"
              />
            </div>
            <div className="flex flex-col items-start gap-6 force-0">
              <label className="text-Title/20/Bold">
                کد تایید را وارد کنید.
              </label>
              <p className="text-Body-OneLine/14/Regular text-gray-900">
                کد تایید به شماره{" "}
                {getValues("phone_number")
                  ? getValues("phone_number")
                  : localStorage.getItem("phone_number")}{" "}
                {""}
                پیامک شده است.
              </p>
            </div>
            <div className="flex flex-col gap-4 force-0 items-center justify-center">
              <Controller
                control={control}
                name={
                  isForgetPassword ? "forget_otpCodeNumber" : "otpCodeNumber"
                }
                render={({ field }) => (
                  <OTPInput
                    key={inputKey}
                    length={OtpLength}
                    inputClassName={`${styleOtpInput} border outline-none text-center rounded-[8px] md:w-[42px] md:h-[42px] h-[32px] w-[32px] m-[3px]`}
                    isNumberInput
                    autoFocus
                    onChangeOTP={(otpCodeNumber: any) => {
                      field.onChange(otpCodeNumber);
                    }}
                  />
                )}
              />
              <div>
                <CustomTimer onResend={handleResend} initialTime={120} />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-3 py-5 ">
            <ButtonComponent
              type="submit"
              isClicked={isButtonDisabled}
              disabled={isButtonDisabled}
              className="w-full h-[40px]"
            >
              تایید
            </ButtonComponent>
            {loginAvailable && !isForgetPassword && (
              <ButtonComponent
                type="button"
                className="w-full h-[40px]"
                onClick={() => goToLogin()}
                bgColor="bg-white"
                textColor="text-primary-600"
                variant="text"
              >
                ورود با رمز عبور
              </ButtonComponent>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default EnterOtp;
